import { render } from "./SummaryBox.vue?vue&type=template&id=b6f79c04"
import script from "./SummaryBox.vue?vue&type=script&lang=js"
export * from "./SummaryBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__